import React from 'react';
import { Button } from 'reactstrap';
import { useNavigationActions } from '../../../../context';

/**
 * Component that displays the confirmation message when a user decides to keep their membership
 * Shows encouragement and provides a way to return to WHOLE Life Club
 */
const StayConfirmation = () => {
  // Get navigation actions from context
  const { returnToWLC } = useNavigationActions();

  return (
    <div className="stay-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-4">Great choice! Your membership is safe.</h5>

        <p className="mb-3">
          We're thrilled you've decided to keep your WHOLE Life Club membership! Your journey toward a healthier,
          happier life continues with full access to all our resources.
        </p>

        <p className="mb-3">
          Remember, we're here to support you every step of the way. Whether you need recipe inspiration, wellness
          guidance, or community support, everything is just a click away.
        </p>

        <p className="mb-4">
          If you ever need help making the most of your membership or have any questions, don't hesitate to reach out to
          our support team.
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" onClick={returnToWLC} size="lg">
            Continue to WHOLE Life Club
          </Button>
        </div>

        <p className="mb-4 text-muted text-center">
          Thank you for being part of the WHOLE Life Club community. Let's keep building healthy habits together!
        </p>
      </div>
    </div>
  );
};

export default StayConfirmation;
